import { ConnectionCalendar, ExternalConnection, ID } from '@griply/types';

export type ConnectionCalendarGroup = {
  connectionId: ID;
  accountEmail: string | null;
  calendars: ConnectionCalendar[];
};

// Calendars are name-sorted across every account, so accounts interleave without this.
export const getCalendarsByConnection = (
  connections: ExternalConnection[],
  calendars: ConnectionCalendar[],
): ConnectionCalendarGroup[] => {
  const calendarsByConnection = calendars.reduce<Map<ID, ConnectionCalendar[]>>(
    (acc, calendar) => {
      const group = acc.get(calendar.connectionId);
      if (!group) {
        acc.set(calendar.connectionId, [calendar]);
        return acc;
      }

      group.push(calendar);
      return acc;
    },
    new Map(),
  );

  return [...calendarsByConnection.entries()].map(
    ([connectionId, groupCalendars]) => ({
      connectionId,
      accountEmail:
        connections.find(({ id }) => id === connectionId)?.providerInfo
          ?.email ?? null,
      calendars: groupCalendars,
    }),
  );
};
